const rn_map_low = new Random_Number( { max_attempts: 50, max: 5, min: 1 } );
const rn_map_high = new Random_Number( { max_attempts: 50, max: 11, min: 6 } );
const nav_options = {
  enableHighAccuracy: false,
  timeout: 20 * 1000,
  maximumAge: 30 * 1000
}

let location_accuracy;
let watch_id;
let update_location_attemps = 0;


const nav_share_location = ( location ) =>
{
  update_location_attemps > 3 ? navigator.geolocation.clearWatch( watch_id ) : handle_user_location( location );
}


const handle_user_location = ( location ) =>
{
  if ( location && !map_active )
  {
    cached_elements.remove_class( '#js-social-map-container', 'permission-denied' );
    update_user_location_details( location );
    init_map();
  }
  else if ( location && map_active && location_accuracy <= 50 )
  {
    navigator.geolocation.clearWatch( watch_id );
  }
  else if ( location && map_active && location_accuracy >= 50 )
  {
    update_user_location_details( location );
    update_marker_position();
    update_location_attemps++;
  }
}


const nav_error = ( e ) =>
{
  if ( e )
  {
    cached_elements.remove_class( '#js-social-map-container', 'loading' );
    cached_elements.set_text( '#js-social-map-popup-msg', get_nav_error_msg( e.code ) );
    cached_elements.add_class( '#js-social-map-container', 'permission-denied' );
    console.log( e )
  }
}


const get_nav_error_msg = ( code ) =>
{
  const access_denied_msg = 'Access denied, please update system or browser settings to share your location';
  const position_unavaible_msg = 'Your position is unavaible';
  const timed_out_msg = 'Request timed out, please try again :)';

  return code === 1 ? access_denied_msg : code === 2 ? position_unavaible_msg : timed_out_msg;
}


const update_user_location_details = ( location ) =>
{
  update_location_accuracy( location.coords.accuracy );
  update_user_locations( location.coords );
}


const update_location_accuracy = ( location ) =>
{
  location_accuracy = location;
}


const capture_user_location = () =>
{

  cached_elements.add_class( '#js-social-map-container', 'loading' );

  if ( navigator.geolocation )
  {
    watch_id = navigator.geolocation.watchPosition( nav_share_location, nav_error, nav_options );
  }
  else
  {
    alert( 'your browser doesnt support geolocation' )
  }
}


const update_user_locations = ( coords ) =>
{
  user.locations.user.lat = coords.latitude;
  user.locations.user.lng = coords.longitude;

  create_fake_locations();
}


const create_fake_locations = () =>
{
  user.locations.friends = [];

  for ( let i = 0; i < user.friends_names.length; i++ )
  {
    user.locations.friends.push( create_fake_coords( i ) )
  }
}


const create_fake_coords = ( i ) =>
{
  const partition = 75;
  return {
    name: user.friends_names[ i ],
    lat: i % 2 ? user.locations.user.lat + random_coord( partition ) : user.locations.user.lat - random_coord( partition ),
    lng: !i % 2 ? user.locations.user.lng + random_coord( partition ) : user.locations.user.lng - random_coord( partition )
  }
}


const random_coord = ( partition ) =>
{
  return ( rn_map_low.get() / rn_map_high.get() ) / partition;
}